import { GetTrackingJourneySummaryArgs } from 'types/api/arguments/get-tracking-journey-summary-args'
import { TrackingJourneySummaryResponse } from 'types/api/response/tracking-journey-summary-response'

import { api } from './api'

export const getTrackingJourneySummary = ({ transactionId }: GetTrackingJourneySummaryArgs) =>
  api.get<TrackingJourneySummaryResponse>(`transactions/${transactionId}/shipment/journey_summary`)
